module.exports = __webpack_public_path__ + "img/logo.a95355c1.png";